module.exports = __webpack_public_path__ + "img/article4.25fb3a61.jpg";